import axios from "@/config/axios";

const initialState = () => {
  return {
    exceptionCases: null,
    exceptionCasesLoading: false,
    exceptionCasesError: null,
  };
};

const state = initialState();

const getters = {
  getExceptionCases: (state) => state.exceptionCases,
  getExceptionCasesLoading: (state) => state.exceptionCasesLoading,
  getExceptionCasesError: (state) => state.exceptionCasesError,
};

const mutations = {
  setExceptionCases(state, data) {
    state.exceptionCases = data;
  },
  setExceptionCasesLoading(state, status) {
    state.exceptionCasesLoading = status;
  },
  setExceptionCasesError(state, error) {
    state.exceptionCasesError = error;
  },
  reset(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  fetchExceptionCasesByFacility: async ({ commit, dispatch }, facility_id) => {
    try {
      commit("setExceptionCasesLoading", true);
      commit("setExceptionCasesError", null);
      commit("setExceptionCases", null);

      // POST call with facility_id in body
      const response = await axios.post(
        "/get-exception-cases/facility",
         facility_id 
      );

      commit("setExceptionCases", response.data);
    } catch (error) {
      commit("setExceptionCasesError", error.response?.data || error.message);
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
    } finally {
      commit("setExceptionCasesLoading", false);
    }
  },
  sendExceptionCasesEmail: async ({ dispatch }, payload) => {
    try {
      const response = await axios.post(
        "/send-email/exception-cases/facility",
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};